
<script>
import New from './New11'
import Edit from '../Edit'
export default {
  mixins: [New, Edit],
}
</script>
